import React from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { TiTimes } from "react-icons/ti";

export default function ViewInfoModal({ show, handleClose }) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="assetInfoModal"
    >
      <Modal.Header
        style={{
          borderBottom: "1px solid #eef2f6",
          padding: "22px 28px",
          position: "relative"
        }}
      >
        <Modal.Title
          style={{
            fontSize: "22px",
            fontWeight: "700",
            color: "#1e2b4d"
          }}
        >
          Asset Information
        </Modal.Title>

        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            right: "20px",
            top: "18px",
            border: "none",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            background: "#6b7280",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <TiTimes size={22} />
        </button>
      </Modal.Header>

      <Modal.Body style={{ padding: "20px 28px 28px" }}>
        {/* Top Asset Card */}
        <div
          style={{
            background: "#f8fafc",
            borderRadius: "8px",
            padding: "20px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
            marginBottom: "26px"
          }}
        >
          <img
            src="/assets/img/laptop.jpg"
            alt=""
            style={{
              width: "54px",
              height: "54px",
              borderRadius: "50%",
              objectFit: "cover"
            }}
          />

          <div>
            <div
              style={{
                fontSize: "17px",
                fontWeight: "700",
                color: "#1e293b"
              }}
            >
              Dell Laptop - #343556656
            </div>

            <div style={{ marginTop: "6px", fontSize: "15px" }}>
              <span style={{ color: "#f97316" }}>AST - 001</span>

              <span
                style={{
                  color: "#f97316",
                  margin: "0 8px"
                }}
              >
                •
              </span>

              <span style={{ color: "#6b7280" }}>
                Assigned on 22 Nov, 2022 10:32AM
              </span>
            </div>
          </div>
        </div>

        {/* Details */}
        <Row>
          <Col md={6} xs={12}>
            <Info label="Type" value="Laptop" />
          </Col>

          <Col md={6} xs={12}>
            <Info label="Brand" value="Dell" />
          </Col>

          <Col md={6} xs={12}>
            <Info label="Category" value="Computer" />
          </Col>

          <Col md={6} xs={12}>
            <Info label="Serial No" value="3647952145678" />
          </Col>

          <Col md={6} xs={12}>
            <Info label="Cost" value="$800" />
          </Col>

          <Col md={6} xs={12}>
            <Info label="Vendor" value="Compusoft Systems Ltd.," />
          </Col>

          <Col md={6} xs={12}>
            <Info label="Warranty" value="12 Jan 2022 - 12 Jan 2026" />
          </Col>

          <Col md={6} xs={12}>
            <Info label="Location" value="46 Laurel Lane, TX 79701" />
          </Col>
        </Row>

        {/* Asset Images */}
        <div style={{ marginTop: "10px" }}>
          <div
            style={{
              fontSize: "15px",
              marginBottom: "14px",
              color: "#374151"
            }}
          >
            Asset Images
          </div>

          <div
            style={{
              display: "flex",
              gap: "12px",
              flexWrap: "wrap"
            }}
          >
            <img
              src="/assets/img/laptop-01.jpg"
              alt=""
              style={{
                width: "88px",
                height: "82px",
                borderRadius: "10px",
                objectFit: "cover"
              }}
            />

            <img
              src="/assets/img/laptop-2.jpg"
              alt=""
              style={{
                width: "88px",
                height: "82px",
                borderRadius: "10px",
                objectFit: "cover"
              }}
            />

            <img
              src="/assets/img/laptop-3.jpg"
              alt=""
              style={{
                width: "88px",
                height: "82px",
                borderRadius: "10px",
                objectFit: "cover"
              }}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function Info({ label, value }) {
  return (
    <div style={{ marginBottom: "26px" }}>
      <div
        style={{
          fontSize: "15px",
          color: "#374151",
          marginBottom: "4px"
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: "17px",
          color: "#1f2937",
          fontWeight: "500"
        }}
      >
        {value}
      </div>
    </div>
  );
}